import { Box, Typography, Card, CardContent, Divider, IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const terminologyData = [
  {
    english: "Principal Amount",
    tamil: "அசல் தொகை",
    meaningEn: "The total loan amount originally approved for the customer.",
    meaningTa: "வாடிக்கையாளருக்கு வழங்கப்பட்ட மொத்த கடன் அளவு."
  },
  {
    english: "Disbursed Amount",
    tamil: "வழங்கப்பட்ட தொகை / கையில் கிடைத்த தொகை",
    meaningEn: "The actual amount handed over to the customer after deducting processing fees or initial interest.",
    meaningTa: "வட்டி அல்லது கட்டணம் பிடித்தம் போக வாடிக்கையாளர் கையில் கொடுக்கப்பட்ட தொகை."
  },
  {
    english: "Equated Installment",
    tamil: "தவணைத் தொகை",
    meaningEn: "The fixed amount to be paid per period (e.g., daily, weekly, or monthly).",
    meaningTa: "தினம், வாரம் அல்லது மாதம் கட்ட வேண்டிய நிலையான தொகை."
  },
  {
    english: "Interest Payable",
    tamil: "செலுத்த வேண்டிய வட்டி",
    meaningEn: "The total profit or interest expected from the loan.",
    meaningTa: "இந்த கடனுக்காக வசூலிக்கப்படும் மொத்த வட்டி லாபம்."
  },
  {
    english: "Amount Recovered",
    tamil: "வசூலான தொகை",
    meaningEn: "The total cash collected so far from the customer.",
    meaningTa: "வாடிக்கையாளரிடமிருந்து இதுவரை வசூலிக்கப்பட்ட பணம்."
  },
  {
    english: "Outstanding Balance",
    tamil: "நிலுவைத் தொகை / பாக்கி",
    meaningEn: "The remaining amount the customer still has to pay.",
    meaningTa: "வாடிக்கையாளர் இன்னும் கட்ட வேண்டிய மீதமுள்ள பணம்."
  },
  {
    english: "Daily Recovery",
    tamil: "இன்றைய வசூல்",
    meaningEn: "The total amount of money collected on this specific day.",
    meaningTa: "இன்று வசூலிக்கப்பட்ட மொத்த பணம்."
  },
  {
    english: "Pending Installments",
    tamil: "மீதமுள்ள தவணைகள்",
    meaningEn: "The number of installments left to be paid.",
    meaningTa: "இன்னும் கட்ட வேண்டிய தவணைகளின் எண்ணிக்கை."
  },
  {
    english: "In Arrears / Missed",
    tamil: "கட்டாத தவணைகள் / பாக்கி",
    meaningEn: "Installments that were missed and are pending from the past.",
    meaningTa: "கடந்த காலத்தில் கட்டாமல் விடுபட்ட தவணைகள்."
  },
  {
    english: "Overdue Tenor",
    tamil: "காலக்கெடு தாண்டிய நாட்கள்",
    meaningEn: "The number of days/weeks the loan has crossed its target completion date.",
    meaningTa: "கடன் முடிவடையும் தேதியை தாண்டி சென்ற நாட்கள் அல்லது வாரங்கள்."
  }
];

export default function Support() {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, pb: 10, maxWidth: '800px', margin: '0 auto', fontFamily: 'Inter, sans-serif' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <IconButton onClick={() => navigate(-1)} sx={{ mr: 2, background: 'var(--bg-elevated)' }}>
          <ArrowBack sx={{ color: 'var(--text-primary)' }} />
        </IconButton>
        <Typography variant="h4" sx={{ fontWeight: 800, color: 'var(--text-primary)' }}>
          Terminology Support / உதவி
        </Typography>
      </Box>

      <Typography sx={{ color: 'var(--text-secondary)', mb: 4 }}>
        This page explains the professional financial terms used in the application in both English and Tamil. 
        <br/>
        இந்த பக்கம் செயலியில் பயன்படுத்தப்படும் நிதி சொற்களை ஆங்கிலம் மற்றும் தமிழில் விளக்குகிறது.
      </Typography>

      {terminologyData.map((term, index) => (
        <Card key={index} sx={{ mb: 2, background: 'var(--bg-card)', border: '1px solid var(--border-subtle)', borderRadius: 3 }}>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, flexWrap: 'wrap' }}>
              <Typography sx={{ fontSize: 18, fontWeight: 700, color: 'var(--accent-blue)' }}>
                {term.english}
              </Typography>
              <Typography sx={{ fontSize: 16, fontWeight: 700, color: 'var(--accent-green)', textAlign: 'right' }}>
                {term.tamil}
              </Typography>
            </Box>
            <Divider sx={{ my: 1, borderColor: 'rgba(255,255,255,0.05)' }} />
            <Box sx={{ mt: 2 }}>
              <Typography sx={{ fontSize: 14, color: 'var(--text-secondary)', mb: 1 }}>
                <strong style={{ color: 'var(--text-primary)' }}>Meaning:</strong> {term.meaningEn}
              </Typography>
              <Typography sx={{ fontSize: 14, color: 'var(--text-muted)' }}>
                <strong style={{ color: 'var(--text-primary)' }}>பொருள்:</strong> {term.meaningTa}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      ))}

    </Box>
  );
}
